import axios from '../axios'
import config from "@/utils/global.js";
/* 
 * 机构管理模块
 */

// 保存
export const save = (data) => {
    return axios({
        url: config.zuul+'/xyj-admin/w/dept/save',
        method: 'post',
        data
    })
}
// 删除
export const batchDelete = (data) => {
    return axios({
        url: config.zuul+'/xyj-admin/w/dept/delete',
        method: 'post',
        data
    })
}
// 查询机构树
export const findDeptTree = () => {
    return axios({
        url: config.zuul+'/xyj-admin/r/dept/findTree',
        method: 'get'
    })
}


// WEBPACK FOOTER //
// ./src/http/moudules/dept.js